import { PriceBreakdown } from '../views/PriceBreakdown';

export class UserDTO {
  id?: number;
  username: string;
  companyId: string;
  userType: UserTypeENUM;
  roles: UserRoleENUM;
  resetPassword: boolean;
  priceBreakdown?: PriceBreakdown;

  constructor(
    id: number | undefined,
    username: string,
    companyId: string,
    userType: UserTypeENUM,
    roles: UserRoleENUM,
    resetPassword: boolean,
    priceBreakdown?: PriceBreakdown,
  ) {
    this.id = id;
    this.username = username;
    this.companyId = companyId;
    this.userType = userType;
    this.roles = roles;
    this.resetPassword = resetPassword;
    this.priceBreakdown = priceBreakdown;
  }
}

export interface LoginResponse {
  bearer: string;
  user: LoginUser;
}

export interface UserValidation {
  username: string;
  companyId: string;
  roles: UserRoleENUM;
}

export interface LoginUser {
  id: string;
  username: string;
  companyId: string;
  roles: string;
  priceBreakdown: PriceBreakdown;
  resetPassword: boolean;
}

export enum UserTypeENUM {}

export enum UserRoleENUM {
  User = 'User',
  Admin = 'Admin',
  SuperAdmin = 'SuperAdmin',
}
